import { ref } from "vue";
import { defineStore } from "pinia";
import { getAppName, getAppCaption, getSystemRevision, getLocale, getCurrentDate } from "@helper/utils.js";

export const useAppStore = defineStore("app", {
    state: () => ({
        appName: getAppName(),
        appCaption: getAppCaption(),
        systemRevision: getSystemRevision(),
        locale: getLocale(),
        permissions: {},
        roles: {},
        superAdminRole: null,
        currentModule: null,
        premiumPeriod: null,
        deputyName: null,
        currentDate: null,
        isCreator: false,
        isAdmin: false,
        isManager: false,
        isMaster: false,
        timeouts: {
            info: 10,
            error: 15,
        },
    }),
    getters: {
        getAppName: (state) => state.appName,
        getAppCaption: (state) => state.appCaption,
        getSystemRevision: (state) => state.systemRevision,
        getLocale: (state) => state.locale,
        getPermissions: (state) => state.permissions,
        getRoles: (state) => state.roles,
        getSuperAdminRole: (state) => state.superAdminRole,
        getIsCreator: (state) => state.isCreator,
        getIsAdmin: (state) => state.isAdmin,
        getIsManager: (state) => state.isManager,
        getIsMaster: (state) => state.isMaster,
        getTimeouts: (state) => state.timeouts,
        // getPremiumPeriod: (state) => state.premiumPeriod,
    },
    actions: {
        setAppName(value) {
            this.appName = value;
        },
        setAppCaption(value) {
            this.appCaption = value;
        },
        setLocale(value) {
            this.locale = value;
        },
    },
});
